import {
  store,
} from '@assets/store'

export const trackingIdsParameter = ()=>{
  const trackingIds = store.app.query()?.get('trackingIds')
  return trackingIds ? `&trackingIds=${trackingIds}` : ''
}